const filterAgencyEndOptions = (options, agencyStart, liveStart) => {
  if (!agencyStart?.value || !liveStart) return [];

  const agencyStartValue = agencyStart.value;

  return options.filter((option) => {
    const optionValue = option.value;

    if (optionValue <= agencyStartValue) return false;

    if (agencyStartValue < liveStart && optionValue > liveStart) return false;

    return true;
  });
};

export default filterAgencyEndOptions;
